import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Col, FormControl } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';
import QualityCheckAnswerButton from 'dashboard/processing/components/QualityCheckAnswerButton';

export default class ConditionSerialNumberComponent extends Component {
  constructor(props) {
    super(props);

    const {
      ItemNumber = '',
      QualityCheckImages = [],
      CustomHTML = '',
      DeterministicQualityCheck = { Answers: [] },
    } = props.qualityCheckRecord;

    this.itemNumber = ItemNumber;
    this.qualityCheckImages = QualityCheckImages;
    this.customHtml = CustomHTML;
    this.answersInChunks = _.chunk(DeterministicQualityCheck.Answers, 2);
    this.inputRef = {};
    this.serialNumber = "";
  }

  componentDidMount() {
    ReactDOM.findDOMNode(this.inputRef).focus();
  }

  handleChange(event) {
    this.serialNumber = (event.target.value || "").trim();
    this.props.onChange(this.serialNumber);
  }

  render() {
    return (
      <div className="product-question">
        <div>
          <div
            className="quality-check-prompt"
            data-item-number={this.ItemNumber}
            data-testid={`quality-check-prompt-${this.props.qualityCheckRecord.qualityCheckType}`}
          ></div>
          {this.customHTML !== '' &&
            <div
              data-testid='custom-html-content'
              style={{ overflow: 'auto' }}
              className="top15 bot15"
              dangerouslySetInnerHTML={{ __html: this.customHtml }}>
            </div>
          }
          {this.qualityCheckImages.map((image, index) => {
            return (
              <span
                style={{
                  'border-radius': 10,
                }}
                key={index}
                className="pright15"
              >
                <img
                  className="bot20"
                  data-testid={'quality-check-image'}
                  style={{
                    'max-height': 350,
                    'max-width': '100%',
                  }}
                  src={image.URL}
                />
              </span>
            );
          })}

          <Col xs={12} className="bot30 top30">
            {this.answersInChunks.map((answersChunk) =>  this.serialNumber.length >= 3 &&
              <div
                key={uuidv4()}
                style={{ flexWrap: 'wrap' }}
                className="set-width flex-box  align-center space-around text-left bot20"
              >
                {answersChunk.map((answer) => (
                  <QualityCheckAnswerButton key={uuidv4()} {...this.props} currentAnswer={answer}></QualityCheckAnswerButton>
                ))}
              </div>
            )}
          </Col>
          <div className="top30 bot30">
            <div>
              <div className="font-size-17   top20 text-left set-width align-center text-bold">{' Serial Number:'}</div>
              <div className="top5 align-center set-width">
                <FormControl
                  ref={(inputRef) => this.inputRef = inputRef}
                  data-testid='condition-serial-number-input'
                  defaultValue=''
                  componentClass="textarea"
                  rows="1"
                  placeholder=""
                  onChange={this.handleChange.bind(this)}
                  type="text" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}